export default __webpack_public_path__ + "static/media/mockupCollector1.a51457b4.png";